import { render, staticRenderFns } from "./CreatePromotion.vue?vue&type=template&id=040b4598&scoped=true&"
import script from "./CreatePromotion.vue?vue&type=script&lang=js&"
export * from "./CreatePromotion.vue?vue&type=script&lang=js&"
import style0 from "./CreatePromotion.vue?vue&type=style&index=0&id=040b4598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b4598",
  null
  
)

export default component.exports